export const setLanguage = (language: string): void => {
  localStorage.setItem("language", language);
};
export const getLanguage = (): string => {
  const language = localStorage.getItem("i18nextLng");
  return language == null ? "en" : language;
};
